module.exports = __webpack_public_path__ + "fonts/VetoSans-MediumItalic.6f4cf1f5.woff";